export const Paths = {
    home: {
        index: "/",
        guide: "/guide",
    },
    history: {
        index: "/history",
    },
    cart: {
        index: "/cart",
        name: "/cart/name",
        shipping: "/cart/shipping",
        details: "/cart/details",
    },
    checkout: {
        index: "/checkout",
    },
    confirmed: {
        index: "/confirmed",
    },
    admin: {
        index: "/admin",
        orderHistory: "/admin/history",
        userManagement: "/admin/users",
        announcements: "/admin/announcements",
    },
    auth: {
        login: "/auth/login",
        logout: "/auth/logout",
    },
    quick: {
        index: "/quick",
        signaturePortraits: "/quick/signature-portraits",
        shadowBoxes: "/quick/shadow-boxes",
        signatureJerseys: "/quick/signature-jerseys",
        sampleFrames: "/quick/sample-frames",
    },
    customize: {
        samplePortraits: "/customize/sample-portraits",
    },
    resub: {
        index: "/resub",
    },
    products: {
        index: "/products",
        product: {
            splat: "/products/:id",
            get: (productId: string) => "/products/" + productId,
        },
    },
};

export default Paths;

/**
 * Regex that matches all SPA routes. Used by the server's catch-all handler to determine
 * whether an unknown path should serve the SPA shell or return a 404.
 * Matches: /, /guide, /history, /cart[/*], /checkout, /confirmed, /admin[/*],
 *          /auth/login, /auth/logout, /quick[/*], /customize/sample-portraits,
 *          /resub, /products[/*]
 */
export const spaRoutesRegex: RegExp = /^\/($|guide($|\/)|history($|\/)|cart($|\/(?:name|shipping|details))|checkout($|\/)|confirmed($|\/)|admin(\/|$)|auth(\/login|\/logout|\/)|quick($|\/(?:signature-portraits|shadow-boxes|signature-jerseys|sample-frames))|customize(\/sample-portraits|$)|resub($|\/)|products($|\/[^/]+)$)/;
/**
 * Returns a regex for the given path. Should be passed a path from the default module export, not a user-input path.
 */
export function getPathRegex(path: string): RegExp {
    switch (path) {
        default:
            throw new Error("Given path does not have a known regex.");

        case Paths.cart.index:
            return /\/cart$/i;
        case Paths.cart.name:
            return /\/cart\/name$/i;
        case Paths.cart.shipping:
            return /\/cart\/shipping$/i;
        case Paths.cart.details:
            return /\/cart\/details$/i;
        case Paths.quick.index:
            return /\/quick\/?$/i;
    }
}
// Quick validation — all cart paths must have a getPathRegex handler
Object.keys(Paths.cart)
    .map((key) => Paths.cart[key])
    .forEach((path) => getPathRegex(path));
